import { WIDGETS_ACTION_TYPES } from './actionsTypes';
import { parseSidebars } from './parser';

const initialState = {
    byId: {},
    allIds: [],
    items: [],

    loading: {
        list: false,
    },
    error: {
        list: null,
    },
    lastUpdated: null,
};

export const widgetsReducer = (state = initialState, action) => {
    switch (action.type) {
        case WIDGETS_ACTION_TYPES.FETCH_LIST_REQUEST: {
            return {
                ...state,
                loading: { ...state.loading, list: true },
                error: { ...state.error, list: null },
            };
        }
        case WIDGETS_ACTION_TYPES.FETCH_LIST_SUCCESS: {
            const { data } = action.payload;
            const { byId, allIds, items } = parseSidebars(data);

            return {
                ...state,
                byId,
                allIds,
                items,
                loading: { ...state.loading, list: false },
                lastUpdated: action.meta.timestamp,
            };
        }
        case WIDGETS_ACTION_TYPES.FETCH_LIST_FAILURE: {
            return {
                ...state,
                loading: { ...state.loading, list: false },
                error: { ...state.error, list: action.payload.error },
            };
        }
        default:
            return state;
    }
};